/* eslint-disable */
import uiConfig from '@onereach/ui-config';
import config from '../env.json';
// @ts-ignore
import runningProjects from 'runningProjects';
// @ts-ignore
import localOverrides from 'localOverrides';

type ExtendedConfig = typeof config & {
  sentry: {
    debug: boolean;
    dsn: string;
    enabled: boolean;
    environment: string;
    errorReplaySessions: number;
    maxBreadcrumbs: number;
    org: string;
    profilesRate: number;
    project: string;
    replaySessions: number;
    tracesSampleRate: number;
    url: string;
  };
};

export default uiConfig(config, localOverrides, runningProjects) as ExtendedConfig;
